import { Component, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ListCustomCell } from '@shared/modules/list/interfaces/list-custom-cell.interface';
import { PROJECT_STAGE_COLORS } from './stages-colors.const';

@Component({
  selector: 'project-stage-cell',
  templateUrl: './project-stage-cell.component.html',
  standalone: true,
  imports: [TranslateModule]
})
export class ProjectStageCellComponent implements ListCustomCell {
  @ViewChild('template') template;

  protected readonly PROJECT_STAGE_COLORS = PROJECT_STAGE_COLORS;
}
